
import { AfterViewInit, Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import icPhone from "@iconify/icons-ic/twotone-phone";
import icMail from "@iconify/icons-ic/twotone-mail";
import icMap from "@iconify/icons-ic/twotone-map";
import icEdit from "@iconify/icons-ic/twotone-edit";
import icDelete from "@iconify/icons-ic/twotone-delete";
import icSearch from "@iconify/icons-ic/twotone-search";
import icAdd from "@iconify/icons-ic/twotone-add";
import icFilterList from "@iconify/icons-ic/twotone-filter-list";
import icMoreHoriz from "@iconify/icons-ic/twotone-more-horiz";
import icFolder from "@iconify/icons-ic/twotone-folder";
import icRefresh from "@iconify/icons-ic/twotone-refresh";
import icCloudDownload from '@iconify/icons-ic/twotone-cloud-download';
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { Subject } from "rxjs";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import {
  BUSINESS_DATA_KEY,
  TRANSACTION_TABLE_LABELS,
  USER_SESSION_KEY,
} from "src/app/Models/constants";
import { ActivatedRoute, Router } from "@angular/router";
import { TransactionsService } from "src/app/services/transactions.service";
import { takeUntil } from "rxjs/operators";
import { BusinessService } from "src/app/services/business.service";
import moment from "moment";
import { MatTableExporterDirective } from "mat-table-exporter";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: 'vex-financial-statment-report',
  templateUrl: './financial-statment-report.component.html',
  styleUrls: ['./financial-statment-report.component.scss']
})
export class FinancialStatmentReportComponent implements OnInit, AfterViewInit {

  menu: { current: { name: string, value: string }, options: { name: string, value: string }[] } = {
    current: { name: 'Financial Statment', value: "topup" },
    options: [
      { name: 'Financial Statment', value: "topup" }
    ]
  }

  displayedColumns: string[] = [
    // "id",
    "reference",
    'libelle',
    'account',
    
    
    'debit',
    'credit',
    
    'end_balance',
    
    'status',
    "created_at",
    
  ];
  dataSource = new MatTableDataSource();
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20, 50];
  totalItems = 0;
  currentPage = 0;
  layoutCtrl = new FormControl("boxed");
  searchCtrl = new FormControl();

  icPhone = icPhone;
  icMail = icMail;
  icMap = icMap;
  icEdit = icEdit;
  icSearch = icSearch;
  icDelete = icDelete;
  icAdd = icAdd;
  icFilterList = icFilterList;
  icMoreHoriz = icMoreHoriz;
  icFolder = icFolder;
  icRefresh = icRefresh;
  icCloudDownload = icCloudDownload;

  statusLabels = TRANSACTION_TABLE_LABELS;
  userData: any;
  unsubscribe$ = new Subject();

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  transactionsData: any;
  transactionType: any;
  hasNoTransactions: boolean;
  userBusinessData: any;
  credentials: string;
  isLoading: boolean;

  @ViewChild(MatTableExporterDirective)
  matTableExporter: MatTableExporterDirective;

  defaultFilterCurrency = ""
  defaultDateStart = ""
  defaultDateEnd = ""
  showFinancialStatment : boolean = false
 
  currentCurrencyBalance = { currency: "", balance: 0, collectionBalance: 0 }
  currencyBalance = [
    { currency: "XOF", balance: 0, collectionBalance: 0 },
    { currency: "XAF", balance: 0, collectionBalance: 0 },
    { currency: "NGN", balance: 0, collectionBalance: 0 },
    { currency: "GHS", balance: 0, collectionBalance: 0 }
  ]
  currenctBalance : string = ''


  constructor(
    private router: Router,
    private transactionsService: TransactionsService,
    private businessService: BusinessService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private snackBar: MatSnackBar
  ) {

     

    const sessionData = JSON.parse(localStorage.getItem(USER_SESSION_KEY));
    this.userData = sessionData;
    this.credentials = `${this.userData?.api_secret_key_live}:${this.userData?.api_public_key_live}`;

    const businessData = localStorage.getItem(BUSINESS_DATA_KEY);
    if (businessData !== "undefined") {
      this.userBusinessData = JSON.parse(businessData);
    }

    if (!sessionData) {
      router.navigate(["/auth/login"]);
    }
    //this.credentials = `${this.userBusinessData?.api_secret_key_live}:${this.userBusinessData?.api_public_key_live}`;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  ngOnInit(): void {
     

    this.route.params.subscribe(params => {
      this.defaultFilterCurrency = params['currency'];
      this.defaultDateStart = params['date_start'];
      this.defaultDateEnd = params['date_end'];
    });
    this.loadTransactions()

     
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngAfterViewInit() {
    // Écouter les événements de pagination
    this.paginator.page
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.currentPage = this.paginator.pageIndex;
        this.pageSize = this.paginator.pageSize;
        this.loadTransactions();
      });
  }

  refreshData() {
    this.loadTransactions();
  }

  getStatusLabel(status: string) {
    return this.statusLabels.find((label) => label.text === status);
  }

  loadTransactions() {
    this.showFinancialStatment = true
    this.isLoading = true;

    // Pagination côté serveur : la page commence à 1 sur le backend, mais pageIndex commence à 0
    const page = this.currentPage + 1;

    this.dataSource = new MatTableDataSource([]);
    this.businessService
      .getUserFinancialStament(
        this.userData.user_id,
        this.defaultFilterCurrency,
        this.defaultDateStart,
        this.defaultDateEnd,
        this.credentials,
        page,
        this.pageSize
      )
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        async (response) => {
          //this.isLoading = false;
          if (response.data && response.data.transactions) {
            this.isLoading= true


            await new Promise<void>(resolve => setTimeout(resolve, 3000));

            // Mettre à jour le nombre total d'éléments pour le paginator
            this.totalItems = response.data.total || response.data.transactions.length;

            this.transactionsData = response.data.transactions.map((details) => {
              details.created_at = moment(details.created_at).format('Y-MM-DD HH:mm:ss');
              details.state = this.getStatusLabel(details.status);
              return details;
            });
            //FILTRER AVEC LA CURRENCY RECUPERE DEPUIS L'URL
            // Note: Le filtrage de currency devrait être fait côté backend maintenant
            if (this.defaultFilterCurrency != "") {
              this.transactionsData = this.transactionsData.filter(item => item.currency == this.defaultFilterCurrency);
            }
            this.hasNoTransactions = response.data.transactions.length === 0 ? true : false;
            this.dataSource = new MatTableDataSource(this.transactionsData);
            // NE PAS assigner le paginator et sort au dataSource pour la pagination serveur
            // this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.isLoading = false

          } else {
            this.isLoading = false
            this.totalItems = 0;
            /*
            this.hasNoTransactions = true;
            const data = [];
            this.dataSource = new MatTableDataSource(data);
            */
          }
        },
        (error) => {
          this.isLoading = false;
          this.totalItems = 0;
          //console.log(error.message);
        }
      );
  }

 

 


























  exportAsXlsx() {
    if (this.isAllowed("7")) {
      // Ouvrir le dialog de confirmation
      const dialogRef = this.dialog.open(DownloadConfirmationDialog, {
        width: '500px',
        data: {
          dateStart: this.defaultDateStart || 'Non spécifiée',
          dateEnd: this.defaultDateEnd || 'Non spécifiée'
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result === true) {
          // L'utilisateur a confirmé, envoyer la requête au backend
          this.requestFinancialStatementDownload();
        }
      });
    } else {
      this.snackBar.open("You are not allowed", "Close", {
        duration: 3000,
      });
    }
  }

  requestFinancialStatementDownload() {
    this.isLoading = true;

    this.businessService
      .requestFinancialStatementReport(
        this.userData.user_id,
        this.defaultFilterCurrency,
        this.defaultDateStart,
        this.defaultDateEnd,
        this.userData.email,
        this.credentials
      )
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (response) => {
          this.isLoading = false;
          this.snackBar.open(
            response.message || "Votre demande a été envoyée avec succès. Vous recevrez le lien de téléchargement par email.",
            "Close",
            {
              duration: 5000,
            }
          );
        },
        (error) => {
          this.isLoading = false;
          this.snackBar.open(
            "Une erreur s'est produite lors de la demande. Veuillez réessayer.",
            "Close",
            {
              duration: 5000,
            }
          );
        }
      );
  }







  isAllowed(habl: string) {

    let habilitations = []
    let isAllow = false
    if (this.userData.secondaryAccount) {
      if (this.userData.habilitations != undefined) {
        habilitations = this.userData.habilitations.split(',')
        for (let hab of habilitations) {
          if (hab == habl) {
            isAllow = true
          }
        }
      }
    } else {
      isAllow = true
    }
    return isAllow
  }


  selectOption(current: { name: string, value: string }) {
    this.menu.current = current;
  }
}

// Composant Dialog pour la confirmation de téléchargement
@Component({
  selector: 'download-confirmation-dialog',
  template: `
    <h2 mat-dialog-title>Download confirmation</h2>
    <mat-dialog-content>
      <p>You are about to download the report between <strong>{{ data.dateStart }}</strong> and <strong>{{ data.dateEnd }}</strong>.</p>
      <p>The download link will be sent to you by email.</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button [mat-dialog-close]="false">Annuler</button>
      <button mat-raised-button color="primary" [mat-dialog-close]="true">Confirmer</button>
    </mat-dialog-actions>
  `,
})
export class DownloadConfirmationDialog {
  constructor(
    public dialogRef: MatDialogRef<DownloadConfirmationDialog>,
    @Inject(MAT_DIALOG_DATA) public data: { dateStart: string; dateEnd: string }
  ) {}
}
